import React, { useMemo } from 'react';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Avatar, useTheme } from '@mui/material';
import LocalizationToggle from './LocalizationToggle';
import { languages } from '.';

const AppBarLocalizationMenu = ({ reload = true, ...props }) => {

    const { i18n } = useTranslation('public');
    const theme = useTheme();

    const [anchorElLocalization, setAnchorElLocalization] = React.useState(null);
    const handleOpenLocalizationMenu = event => setAnchorElLocalization(event.currentTarget);
    const handleCloseLocalizationMenu = () => setAnchorElLocalization(null);

    const currentLanguage = useMemo(() => {
        return find(languages, lang => lang.id == i18n.language)
    }, [i18n, theme?.direction])

    return (
        <Box {...props}>
            <IconButton disableRipple sx={{ p: 1, ':hover': { backgroundColor: 'transparent !important' } }} onClick={handleOpenLocalizationMenu} >
                <Avatar sx={{ width: '20px', height: '20px' }} src={currentLanguage?.imageSource} />
                <Typography sx={{ marginInlineStart: 1, color: 'white !important', fontSize: '14px', fontStyle: 'normal', fontWeight: 400, lineHeight: '20px' }}>{currentLanguage?.miniTitle}</Typography>
            </IconButton>
            <Menu
                sx={{ mt: '50px' }}
                id="menu-appbar"
                anchorEl={anchorElLocalization}
                anchorOrigin={{ vertical: 'bottom', horizontal: i18n.dir() === "rtl" ? 'left' : 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'bottom', horizontal: i18n.dir() === "rtl" ? 'left' : 'right' }}
                open={Boolean(anchorElLocalization)}
                onClose={handleCloseLocalizationMenu}
            >
                <LocalizationToggle reload={true} onClick={handleCloseLocalizationMenu} />
            </Menu>
        </Box>
    );
}

export default AppBarLocalizationMenu;
